import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

export interface VendorRepresentative {
  vendorId: number;
  vendorName: string;
  pointOfContact: string;
  email: string | null;
  contact: string | null;
  status?: string;
  lastLogin?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AccessControlService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}
  /**
   * Extracts and returns the filtered value from a keyboard event.
   * @param event - The keyboard event triggered by the user.
   * @returns The trimmed and sanitized search value.
   */
  getFilteredValue(event: KeyboardEvent): string {
    const inputElement = event.target as HTMLInputElement;
    return inputElement.value.trim();
  }

  /**
   * Filters an array of objects based on a search term.
   * @param data - The array of objects to filter.
   * @param searchTerm - The term to search for.
   * @returns A filtered array of objects.
   */
  filterData<T extends object>(data: T[], searchTerm: string): T[] {
    const lowerCaseTerm = searchTerm.toLowerCase();
    return data.filter((item) =>
      Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(lowerCaseTerm),
      ),
    );
  }

  getVendorRepresentatives(): Observable<{
    status: string;
    reason: string;
    data: VendorRepresentative[];
  }> {
    return this.http.get<{
      status: string;
      reason: string;
      data: VendorRepresentative[];
    }>(`${this.baseUrl}/ops/hiring-vendor-details`);
  }

  saveVendorRepresentative(body: any, method: 'post' | 'put'): Observable<any> {
    const url = `${this.baseUrl}/ops/hiring-vendor-details`;
    return method === 'post'
      ? this.http.post(url, body)
      : this.http.put(url, body);
  }
  getAllVendors(): Observable<any> {
    return this.http.get(`${this.baseUrl}/hiring/vendors`);
  }
}
